import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route за /admin/email/* (index, stats, templates, settings).
export const Route = createFileRoute("/_authenticated/admin/email")({
  component: () => <Outlet />,
});
